import React from "react";
import styled from "styled-components"; // Opcional si usas styled-components
import { FlexContainer, PaddingContainer, Heading, StyledDivider} from "../styles/Global.styled";
import HeaderTyping from './ui/HeaderTyping';
import {motion} from 'framer-motion';
import { Button, Image, } from "../styles/Global.styled";
import { FaGithub } from "react-icons/fa";
import { BsLinkedin } from "react-icons/bs";
import ArrowButton from './ui/ArrowButton';

const Home = () => {
  return (
    <PaddingContainer 
        id="home"
        left="8%"
        right="8%"
        top="20%"
        bottom="10%"
        tabletLeft="2%"
        tabletRight="2%"
        responsiveLeft='1rem'
        responsiveRight='1rem'
        responsiveTop='8rem'
        
    > 

        <FlexContainer align="center" fullWidthChild gap="2px" direction='column'>
            {/** --left content-- */} 
          
                <Heading size="h5" bottom='0.5rem' right= "0.5rem" align='center'><HeaderTyping text='Hola!' showCursor={true} delay={0} ultimo={false} typeSpeed={70}> </HeaderTyping></Heading>
                <Heading size="h4"as="h4" right= "0.5rem" align='center'>   
                    <HeaderTyping text='Mi nombre es' showCursor={true} delay={700} ultimo={false} typeSpeed={70}> </HeaderTyping> 
                </Heading>  
                <Heading  size="h3" as="h3" align='center'>  <HeaderTyping text='Fabián Sanabria' showCursor={true} azul={true}  delay={2000} ultimo={false} typeSpeed={70}> </HeaderTyping>  </Heading>
                <Heading size="h5" as="h5" align='center'> 
                    <FlexContainer align='center' gap='0.5rem'> 
                    <HeaderTyping text='y soy' showCursor={true} delay={3400} ultimo={false} typeSpeed={70}> </HeaderTyping> 
                    <HeaderTyping text='Ingeniero en Informática.' showCursor={true} azul={true} delay={3700} ultimo={true} typeSpeed={70}> </HeaderTyping>
                    </FlexContainer> 
                </Heading>
                
                {/**  --social icons-- */}
               
                <StyledDivider /> 
               
                <PaddingContainer top='10px' bottom='30px'>
                    <FlexContainer direction="row" align="center" gap="20px" >
                        <a href="https://www.linkedin.com/in/fabiansanabriaampuero/" style={{ zIndex: "2" }}>
                        <Button color="white" radius="30%" size="60px" >
                            <BsLinkedin size="1.5rem" style={{ position: "relative", right: "11px", color:'#007bff' }}/>
                        </Button>
                        </a>

                        <a href="https://github.com/FabianSanabria" style={{ zIndex: "2" }}>
                        <Button color="white" radius="30%" size="60px">
                            <FaGithub size="1.5rem" style={{ position: "relative", right: "11px" }}/>
                        </Button>
                        </a>
                    </FlexContainer>
           
                    </PaddingContainer>
               
          
             {/**   --right content--   */}

        </FlexContainer>
        <FlexContainer align='center' justify='center'>
        <ArrowButton targetId="about-me" />
        </FlexContainer>
    </PaddingContainer>
  );
};

export default Home;
